import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import { useRawApi } from "./core-module/hook/connectingHooks";

export const ApiContext = React.createContext({});

export const useApi = function () {
  return React.useContext(ApiContext);
};

export default function App(props) {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("Error");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [apiContextObject, setApiContextObject] = useState(null);
  const rawApi = useRawApi();
  const dispatch = useDispatch();
  const jrr = useSelector((store) => store.services.api.JRR);

  useEffect(() => {
    const refreshAllConnectsEvent = new Event("refreshAllConnects");

    function refreshAllActiveSubscriptions() {
      window.dispatchEvent(refreshAllConnectsEvent);
    }

    async function apiCommonCall(callback, ...apiparams) {
      let ret = null;
      try {
        ret = await callback(...apiparams);

        if (ret?.message) {
          setSnackbarMessage(ret.message);
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
        }
      } catch (e) {
        setSnackbarMessage(e.message);
        setSnackbarOpen(true);
        setSnackbarSeverity("error");
        console.log(e.message);
        console.trace();
        ret = false;
      }

      return ret;
    }

    async function fetchApi(...apiparams) {
      return await apiCommonCall(rawApi.fetchApi, ...apiparams);
    }

    async function apiGet(...apiparams) {
      return await apiCommonCall(rawApi.get, ...apiparams);
    }

    async function apiPost(...apiparams) {
      const res = await apiCommonCall(rawApi.post, ...apiparams);
      refreshAllActiveSubscriptions();
      return res;
    }

    async function apiPut(...apiparams) {
      const res = await apiCommonCall(rawApi.put, ...apiparams);
      refreshAllActiveSubscriptions();
      return res;
    }

    async function apiDelete(...apiparams) {
      const res = await apiCommonCall(rawApi.del, ...apiparams);
      refreshAllActiveSubscriptions();
      return res;
    }

    setApiContextObject({
      get: apiGet,
      post: apiPost,
      put: apiPut,
      delete: apiDelete,
      fetchApi: fetchApi,
      refreshAll: refreshAllActiveSubscriptions,
    });

    return;
    // return () => dispatch(dropActiveConnects());
  }, []);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarOpen(false);
  };

  if (apiContextObject == null || !jrr) {
    //If no JRR, defer rendering of anything until jrr because with no JRR, it breaks everything downstream
    return null;
  }

  return (
    <ApiContext.Provider value={apiContextObject}>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={10000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {props.children}
    </ApiContext.Provider>
  );
}
